module.exports = __webpack_public_path__ + "static/helmet-9e854fcfb291801d6eb14914e1f7c210.png";